import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import LandingPage from './pages/Portfolio/Landing'
import ProjectDetailPage from './pages/Portfolio/ProjectDetail'
import NotFoundPage from './components/Pages/NotFound'
import PetPolicyPage from './modules/AnimalCircle/pages/Policy'
import StickyPage from './pages/Sticky/Sticky'
import routes from './config/settings/routes'

/**
 * The Routing's component.
 */
const routeComponents = [
  <Route path={routes.landing} element={<LandingPage />} />,
  <Route path={routes.root} element={<LandingPage />} />,
  <Route path={routes.projectDetail} element={<ProjectDetailPage />} />,
  <Route path={routes.sticky} element={<StickyPage />} />,
  <Route path={routes.petPolicy} element={<PetPolicyPage />} />,
  <Route path="*" element={<NotFoundPage />} />,
]

const Routing = createBrowserRouter(createRoutesFromElements(routeComponents))

export default Routing
